export const SITE_TYPE_DAM = 'dam';
export const SITE_TYPE_RIVER = 'river';
export const SITE_TYPE_TRIBUTARY = 'tributary';
export const SITE_TYPE_TIDE = 'tide';
export const SITE_TYPE_TIDE_FORECAST = 'tide_forecast';

export const SITE_TYPE_CATEGORY_RIVERINE = [SITE_TYPE_DAM, SITE_TYPE_RIVER, SITE_TYPE_TRIBUTARY];
export const SITE_TYPE_CATEGORY_OCEAN = [SITE_TYPE_TIDE, SITE_TYPE_TIDE_FORECAST];

export const STATUS_NO_DATA = 'no_data';
export const STATUS_NO_RECENT_DATA = 'no_recent_data';
export const STATUS_WATCH = 'watch';
export const STATUS_WARNING = 'warning';
export const STATUS_NO_CHANGE = 'no_change';

export const MINOR_WARNING_COLOR = '#A68200';
export const MODERATE_WARNING_COLOR = '#A62F00';
export const MAJOR_WARNING_COLOR = '#8C0000';

export const FLOOD_LEVEL_MINOR = 'minor';
export const FLOOD_LEVEL_MODERATE = 'moderate';
export const FLOOD_LEVEL_MAJOR = 'major';

export const FLOOD_LEVEL_MARKERS = {
  [FLOOD_LEVEL_MINOR]: {
    label: 'Minor Flood Level',
    color: MINOR_WARNING_COLOR
  },
  [FLOOD_LEVEL_MODERATE]: {
    label: 'Moderate Flood Level',
    color: MODERATE_WARNING_COLOR,
  },
  [FLOOD_LEVEL_MAJOR]: {
    label: 'Major Flood Level',
    color: MAJOR_WARNING_COLOR
  },
}
